/** রিপোর্ট। */
export const reports = {
    title: "রিপোর্ট",
    description: "বিক্রি, স্টক, টাকা, শিফট, ডেলিভারি ও কাস্টমার। প্রতিটি সংখ্যা থেকে তার পেছনের হিসাব খোলা যায়।",
    open: "রিপোর্ট খুলুন",
    back: "সব রিপোর্ট",
    groups: {
        sales: "বিক্রি",
        stock: "স্টক",
        finance: "টাকা-পয়সা",
        pos: "পয়েন্ট অব সেল",
        delivery: "ডেলিভারি",
        customers: "কাস্টমার",
    },
    names: {
        sales_summary: "বিক্রির সারাংশ",
        product_profit: "পণ্যভিত্তিক লাভ",
        orders: "অর্ডার",
        returns: "ফেরত",
        stock_valuation: "স্টকের মূল্য",
        stock_movements: "স্টকের আসা-যাওয়া",
        dead_stock: "অবিক্রীত স্টক",
        low_stock: "ঋণাত্মক ও কম স্টক",
        profit_loss: "লাভ-ক্ষতি",
        vat: "ভ্যাট",
        receivables: "পাওনা",
        payables: "দেনা",
        expenses: "খরচ",
        transactions: "টাকার লেনদেন",
        shifts: "শিফট ও Z-রিপোর্ট",
        price_variances: "দামের পার্থক্য",
        review_queue: "POS রিভিউ তালিকা",
        delivery_performance: "ডেলিভারির ফলাফল",
        customers: "কাস্টমার",
    },
    about: {
        sales_summary: "দিন, ঘণ্টা, পণ্য, ক্যাটাগরি, ব্র্যান্ড, কর্মী, চ্যানেল, পেমেন্ট বা শাখাভিত্তিক বিক্রি।",
        product_profit: "প্রতিটি পণ্যের আয়, খরচ ও মার্জিন।",
        orders: "এই সময়ের প্রতিটি বিক্রি, নিট পরিমাণসহ।",
        returns: "ফেরত আসা পণ্য, মূল্য ও রিফান্ডসহ।",
        stock_valuation: "গড় খরচে হাতে থাকা স্টকের মূল্য, শাখাভিত্তিক।",
        stock_movements: "কোন পণ্য কখন কোথায় গেল।",
        dead_stock: "অনেক দিন বিক্রি না হওয়া স্টক।",
        low_stock: "যা শূন্যের নিচে বা রি-অর্ডার সীমায়।",
        profit_loss: "বিক্রি − ফেরত − ছাড় − খরচ − ব্যয় = নিট লাভ।",
        vat: "মাসভিত্তিক আদায় করা ভ্যাট, ফেরতের ভ্যাট বাদে।",
        receivables: "কাস্টমার ও কুরিয়ারের কাছে আপনার পাওনা।",
        payables: "সাপ্লায়ারের কাছে আপনার দেনা, বয়সভিত্তিক।",
        expenses: "এই সময়ের প্রতিটি খরচ।",
        transactions: "প্রতিটি টাকার আসা-যাওয়া, যেমন লেখা হয়েছে।",
        shifts: "প্রতিটি শিফটের প্রত্যাশিত, গোনা ক্যাশ ও পার্থক্য।",
        price_variances: "অফলাইনে বর্তমান দাম ছাড়া অন্য দামে বিক্রি।",
        review_queue: "সিঙ্কে আটকানো বা যাচাইয়ের জন্য চিহ্নিত বিল।",
        delivery_performance: "কুরিয়ার ও জেলাভিত্তিক ডেলিভারি বনাম ফেরত।",
        customers: "সেরা কাস্টমার, তাদের বকেয়া ও কতজন আবার এসেছেন।",
    },
    filters: {
        from: "শুরু",
        to: "শেষ",
        location: "শাখা",
        allLocations: "সব শাখা",
        channel: "চ্যানেল",
        allChannels: "সব চ্যানেল",
        groupBy: "যেভাবে ভাগ",
        days: "বিক্রি হয়নি (দিন)",
        status: "অবস্থা",
        run: "দেখান",
    },
    groupBy: {
        day: "দিন",
        hour: "ঘণ্টা",
        product: "পণ্য",
        category: "ক্যাটাগরি",
        brand: "ব্র্যান্ড",
        staff: "কর্মী",
        channel: "চ্যানেল",
        payment_method: "পেমেন্ট পদ্ধতি",
        location: "শাখা",
    },
    reviewStatus: { open: "খোলা", resolved: "নিষ্পন্ন" },
    total: "মোট",
    repeatRate: "আবার আসা কাস্টমার: {{rate}}",
    empty: "এই সময়ে কিছু নেই।",
    emptyBody: "আরও লম্বা সময় বা অন্য শাখা বেছে দেখুন।",
    truncated: "প্রথম {{count}}টি সারি দেখানো হলো। সবগুলোর জন্য রিপোর্ট এক্সপোর্ট করুন।",
    rebuild: "সারাংশ আবার হিসাব",
    rebuildDone: "{{days}} দিনের সারাংশ আবার হিসাব হচ্ছে। এক মিনিটে সংখ্যা হালনাগাদ হবে।",
    export: {
        label: "এক্সপোর্ট",
        working: "ফাইল তৈরি হচ্ছে…",
        started: "ফাইল তৈরি হচ্ছে। তৈরি হলে খুলবে, নোটিফিকেশনেও পাবেন।",
        ready: "আপনার ফাইল তৈরি।",
        later: "এখনো তৈরি হচ্ছে। তৈরি হলে নোটিফিকেশন পাবেন।",
        failed: "ফাইল তৈরি করা যায়নি। আবার চেষ্টা করুন।",
        title: "রিপোর্ট এক্সপোর্ট",
        summary: "{{rows}}টি সারি · তৈরি {{at}}",
        download: "{{format}} ডাউনলোড",
        formats: { xlsx: "এক্সেল (.xlsx)", csv: "CSV", pdf: "PDF" },
    },
    columns: {
        date: "তারিখ",
        orders: "অর্ডার",
        gross_sales: "মোট বিক্রি",
        discounts: "ছাড়",
        net_sales: "নিট বিক্রি",
        returns: "ফেরত",
        cogs: "পণ্যের খরচ",
        gross_profit: "মোট লাভ",
        margin: "মার্জিন",
        channel: "চ্যানেল",
        location: "শাখা",
        product: "পণ্য",
        category: "ক্যাটাগরি",
        brand: "ব্র্যান্ড",
        sku: "SKU",
        qty: "পরিমাণ",
        sales: "বিক্রি",
        net: "নিট",
        hour: "ঘণ্টা",
        staff: "কর্মী",
        payment_method: "পেমেন্ট পদ্ধতি",
        payments: "পেমেন্ট",
        received: "পাওয়া",
        refunded: "ফেরত দেওয়া",
        qty_sold: "বিক্রির পরিমাণ",
        qty_returned: "ফেরতের পরিমাণ",
        revenue: "আয়",
        profit: "লাভ",
        number: "নং",
        status: "অবস্থা",
        vat: "ভ্যাট",
        total: "মোট",
        order: "অর্ডার",
        kind: "ধরন",
        reason: "কারণ",
        refund_method: "রিফান্ড",
        value: "মূল্য",
        refund: "রিফান্ড",
        products: "পণ্য",
        negative: "শূন্যের নিচে",
        on_hand: "হাতে আছে",
        avg_cost: "গড় খরচ",
        type: "ধরন",
        balance: "ব্যালেন্স",
        unit_cost: "একক খরচ",
        last_sale: "শেষ বিক্রি",
        state: "অবস্থা",
        reorder_point: "রি-অর্ডার সীমা",
        opened_by: "খুলেছেন",
        opened_at: "খোলা",
        closed_at: "বন্ধ",
        float: "ফ্লোট",
        cash_sales: "ক্যাশ বিক্রি",
        cash_refunds: "ক্যাশ ফেরত",
        cash_in: "ক্যাশ ইন",
        cash_out: "ক্যাশ আউট",
        expected: "প্রত্যাশিত",
        counted: "গোনা",
        variance: "বেশি / কম",
        list_price: "টিলের দাম",
        charged: "নেওয়া দাম",
        server_price: "বর্তমান দাম",
        difference: "পার্থক্য",
        reasons: "কারণ",
        detail: "বিস্তারিত",
        courier: "কুরিয়ার",
        district: "জেলা",
        booked: "বুক করা",
        delivered: "ডেলিভারি",
        partial: "আংশিক ডেলিভারি",
        returned: "ফেরত",
        open: "পথে",
        success_rate: "সফলতার হার",
        cod: "COD",
        customer: "কাস্টমার",
        phone: "ফোন",
        dues: "বকেয়া",
        repeat_rate: "আবার আসার হার",
        line: "খাত",
        name: "নাম",
        amount: "পরিমাণ",
        period: "সময়কাল",
        taxable_sales: "বিক্রি (ভ্যাট বাদে)",
        returns_vat: "ফেরতের ভ্যাট",
        net_vat: "নিট ভ্যাট",
        supplier: "সাপ্লায়ার",
        current: "০–৩০ দিন",
        days_31_60: "৩১–৬০ দিন",
        days_61_90: "৬১–৯০ দিন",
        over_90: "৯০ দিনের বেশি",
        advance: "অগ্রিম",
        description: "বিবরণ",
        method: "পদ্ধতি",
        note: "নোট",
    },
    lines: {
        gross_sales: "মোট বিক্রি",
        discounts: "বাদ: ছাড়",
        net_sales: "নিট বিক্রি (ভ্যাট বাদে)",
        returns: "বাদ: ফেরত",
        cogs: "বাদ: বিক্রিত পণ্যের খরচ",
        gross_profit: "মোট লাভ",
        expense: "খরচ",
        total_expenses: "বাদ: খরচ",
        courier_charges: "বাদ: কুরিয়ার চার্জ",
        cash_over_short: "ক্যাশ বেশি / কম",
        net_profit: "নিট লাভ",
    },
    values: {
        state: { negative: "শূন্যের নিচে", low: "কম" },
        receivable: { customer: "কাস্টমারের বকেয়া", courier: "কুরিয়ারের কাছে COD" },
        variance: { stale_price: "টিলে পুরোনো দাম", override: "টিলে দাম বদল" },
    },
};
//# sourceMappingURL=reports.js.map